module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.bd19ad60.ttf";